<template>
  <v-menu
    v-model="filterMenu"
    :disabled="disabled"
    bottom
    :nudge-bottom="35"
    :min-width="filtersCount <= 10 ? 650 : 1000"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on: menu }">
      <ToolbarIconButton
        :icon="'filter_list'"
        :tooltip="'Фильтр'"
        data-test="filterButton"
        v-on="{ ...menu }"
      />
    </template>

    <v-card>
      <v-card-title class="py-0">
        <v-layout column>
          <v-flex>
            <h2 class="title my-3">
              Фильтр
            </h2>
          </v-flex>
          <v-layout row>
            <v-flex xs6>
              <v-select
                v-model="selected"
                :items="filters"
                label="Сохранённые фильтры"
                hide-details
                item-text="title"
                item-value="id"
                return-object
                menu-props="offsetY"
                outline
                clearable
                no-data-text="Данных нет"
                @input="getSavedFilter"
              >
                <template v-slot:selection="data">
                  <span :selected="data.selected">
                    {{ data.item.title }}
                  </span>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-tile-content v-text="data.item.title" />
                    <v-list-tile-action>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-if="data.item.isShared"
                            color="blue accent-1"
                            v-on="on"
                          >
                            flag
                          </v-icon>
                        </template>
                        <span>Общий фильтр</span>
                      </v-tooltip>
                    </v-list-tile-action>
                  </template>
                </template>
              </v-select>
            </v-flex>
            <v-flex xs2>
              <v-layout>
                <v-menu
                  v-model="menuSave"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  :disabled="isDisabledFilter && !!selected"
                  menu-props="offsetY"
                >
                  <v-btn
                    slot="activator"
                    icon
                    small
                    :disabled="isDisabledFilter && !!selected"
                    class="mb-0 mt-3"
                  >
                    <v-icon color="grey darken-1">
                      save
                    </v-icon>
                  </v-btn>
                  <v-card>
                    <v-card-text>
                      <v-text-field
                        v-model="filterTitle"
                        label="Имя фильтра"
                      />
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        small
                        flat
                        color="primary"
                        :disabled="!filterTitle"
                        @click="saveFilter"
                      >
                        Сохранить
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
                <v-btn
                  v-if="selected"
                  icon
                  small
                  :disabled="isDisabledFilter"
                  class="mb-0 mt-3 ml-0 mr-3"
                  @click="deleteFilter(selected)"
                >
                  <v-icon color="grey darken-1">
                    delete
                  </v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs4>
              <v-switch
                v-model="isShared"
                hide-details
                label="Общий фильтр"
                clss="mx-2 mt-1"
                :disabled="isDisabledFilter || !selected"
                @change="changedIsShared"
              />
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>

      <v-divider class="mt-2" />

      <v-card-text>
        <v-layout
          row
          wrap
          align-end
        >
          <v-flex
            v-for="(item, index) in filter"
            :key="index"
            :xs12="filtersCount <= 10 ? true : false"
            :xs6="filtersCount > 10 ? true : false"
            :class="{ 'pr-1': filtersCount > 10, 'pl-1': filtersCount > 10 }"
            class="my-1"
          >
            <v-text-field
              v-if="item.type === 'text'"
              v-model="item.value"
              :label="item.title"
              hide-details
              outline
              height="44"
              @change="isChanged = true"
            />

            <v-text-field
              v-if="item.type === 'phone'"
              v-model="item.value"
              :label="item.title"
              mask="+##(###)###-##-##"
              hide-details
              outline
              height="44"
              @change="isChanged = true"
            />

            <app-boolean-select
              v-if="item.type === 'bool'"
              v-model="item.value"
              :label="item.title"
              :clearable="true"
              hide-details
              @input="isChanged = true"
            />

            <MultipleReferenceCompact
              v-if="item.type === 'reference'"
              v-model="item.value"
              :label="item.title"
              :resource="item.resource"
              :disable-add="true"
              :no-route="store === 'shippings' ? true : false"
              :empty-value="item.emptyValue"
              :params="item.params"
              @input="isChanged = true"
            />

            <v-layout v-if="item.type === 'date'">
              <v-flex
                xs6
                class="pr-1"
              >
                <app-date-picker
                  v-model="item.valueFrom"
                  :label="item.title + ' c'"
                  :without-initial-data="true"
                  :incoming-class="'mb-0'"
                  :is-manual-edit="item.isManualEdit"
                  :clearable="true"
                  @input="isChanged = true"
                />
              </v-flex>
              <v-flex
                xs6
                class="pl-1"
              >
                <app-date-picker
                  v-model="item.valueTo"
                  :label="item.title + ' по'"
                  :without-initial-data="true"
                  :incoming-class="'mb-0'"
                  :is-manual-edit="item.isManualEdit"
                  :clearable="true"
                  @input="isChanged = true"
                />
              </v-flex>
            </v-layout>

            <MultipleEnumSelect
              v-if="item.type === 'enum'"
              v-model="item.value"
              :label="item.title"
              :resource="item.resource"
              @input="isChanged = true"
            />

            <v-layout v-if="item.type === 'decimal'">
              <v-flex
                xs6
                class="pr-1"
              >
                <v-text-field
                  v-model="item.valueFrom"
                  :label="item.title + ' c'"
                  hide-details
                  outline
                  height="44"
                  @change="isChanged = true"
                />
              </v-flex>
              <v-flex
                xs6
                class="pl-1"
              >
                <v-text-field
                  v-model="item.valueTo"
                  :label="item.title + ' по'"
                  hide-details
                  outline
                  height="44"
                  @change="isChanged = true"
                />
              </v-flex>
            </v-layout>

            <v-layout v-if="item.type === 'int'">
              <v-flex
                xs6
                class="pr-1"
              >
                <v-text-field
                  v-model="item.valueFrom"
                  :label="item.title + ' c'"
                  hide-details
                  outline
                  height="44"
                  @change="isChanged = true"
                />
              </v-flex>
              <v-flex
                xs6
                class="pl-1"
              >
                <v-text-field
                  v-model="item.valueTo"
                  :label="item.title + ' по'"
                  hide-details
                  outline
                  height="44"
                  @change="isChanged = true"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <SaveBtn @click="apply" />
        <CancelBtn @click="filterMenu = !filterMenu" />
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import * as dataListApi from "../../backend/dataListApi.js";
import ToolbarIconButton from "../ToolbarIconButton.vue";
import { userRoles } from "../../enums/user-roles.js";
import auth from "../../auth.js";

export default {
  components: {
    ToolbarIconButton,
  },
  props: ["store", "disabled"],
  data() {
    return {
      filterMenu: false,
      filter: null,
      isChanged: false,
      selected: null,
      menuSave: false,
      filterTitle: "",
      isShared: false,
    };
  },
  computed: {
    quickFilter() {
      return this.$store.getters[`${this.store}/quickFilter`];
    },
    filtersCount() {
      if (this.filter) {
        return Object.keys(this.filter).length;
      } else {
        return 0;
      }
    },
    filters() {
      return this.$store.getters[`${this.store}/filters`];
    },
    storeFilter: {
      get() {
        return this.$store.getters[`${this.store}/filter`];
      },
      set() {
        return this.$store.commit(
          `${this.store}/setFilter`,
          this.copyFilter(this.filter),
        );
      },
    },
    storeIsShared: {
      get() {
        return this.$store.getters[`${this.store}/isShared`];
      },
      set() {
        return this.$store.commit(`${this.store}/setIsShared`, this.isShared);
      },
    },
    isDisabledFilter() {
      const user = auth.getUser();
      if (
        user.roles.find(r => r.id === userRoles.Admin) ||
        user.id === this.selected?.userId
      ) {
        return false;
      }
      return true;
    },
  },
  watch: {
    filterMenu(value) {
      if (value) {
        this.filter = this.copyFilter(this.storeFilter);
        this.isShared = this.storeIsShared;
        if (this.quickFilter) {
          this.selected = this.quickFilter;
        }
      } else {
        this.filter = null;
        this.selected = null;
        this.isChanged = false;
        this.isShared = false;
      }
    },
    menuSave(value) {
      if (value) {
        if (this.selected) {
          this.filterTitle = this.selected.title;
        }
      } else {
        this.filterTitle = "";
      }
    },
  },
  methods: {
    apply() {
      if (this.isChanged) {
        this.$store.dispatch(`${this.store}/changeFilter`);
      }
      if (this.selected && !this.isChanged) {
        this.$store.dispatch(
          `${this.store}/applyQuickFilter`,
          this.selected.id,
        );
      }
      if (this.selected && this.isChanged) {
        this.$store.dispatch(`${this.store}/changeFilter`);
        this.selected = null;
        this.isShared = false;
      }
      this.filterMenu = false;
      this.isChanged = false;
      this.storeFilter = this.copyFilter(this.filter);
      this.storeIsShared = this.isShared;

      const parsed = JSON.stringify(this.storeFilter);
      localStorage.setItem("filter", parsed);
    },
    copyFilter(source) {
      const copy = {};
      for (const prop in this.storeFilter) {
        if (prop === "id") {
          copy.id = source.id;
          continue;
        }
        if (Object.prototype.hasOwnProperty.call(source, prop)) {
          copy[prop] = { ...source[prop] };
        } else {
          copy[prop] = { ...this.storeFilter[prop] };
        }
        if (
          (source[prop]?.type === "reference" ||
            source[prop]?.type === "enum") &&
          source[prop]?.value
        ) {
          copy[prop].value = source[prop].value.map(i => {
            return { ...i };
          });
        }
      }
      return copy;
    },
    async getSavedFilter(filter) {
      if (filter) {
        const res = await dataListApi.getSavedFilter(filter.id);
        this.filter = this.copyFilter(res.data.Filter);
        this.isShared = res.data.IsShared;
      } else {
        this.filter = this.copyFilter(this.storeFilter);
      }
    },
    async saveFilter() {
      const filter = {
        title: this.filterTitle,
        page: this.store,
        filter: this.filter,
        isShared: this.isShared,
        userId: this.filter.userId,
      };
      if (this.selected) {
        const res = await dataListApi.updateSavedFilter(
          this.selected.id,
          filter,
        );
        this.$store.commit(`${this.store}/setFilters`, res);
        this.selected = this.filters.find(f => f.title === this.filterTitle);
        this.filterTitle = this.selected.title;
        this.menuSave = false;
        this.isChanged = false;
        this.showInfo("Фильтр изменён");
      } else {
        const res = await dataListApi.createSavedFilter(filter);
        this.$store.commit(`${this.store}/setFilters`, res);
        this.selected = this.filters.find(f => f.title === filter.title);
        this.$store.dispatch(
          `${this.store}/applyQuickFilter`,
          this.selected.id,
        );
        this.filterTitle = "";
        this.menuSave = false;
        this.isChanged = false;
        this.showInfo("Фильтр добавлен");
      }
    },
    async deleteFilter(filter) {
      let confirmText;
      if (this.selected.isShared) {
        confirmText =
          "Это общий фильтр доступный всем пользователям. Подтверждая это действие, фильтр будет удален у всех пользователей системы. \n Удалить фильтр?";
      } else {
        confirmText = "Удалить фильтр?";
      }

      if (confirm(confirmText)) {
        const res = await dataListApi.deleteSavedFilter(this.store, filter.id);
        this.showInfo("Фильтр удалён");
        this.$store.commit(`${this.store}/setFilters`, res);
        this.$store.dispatch(`${this.store}/clearQuickFilter`);
        this.selected = null;
        this.isShared = false;
        this.filter = this.copyFilter(this.storeFilter);
      }
    },
    async changedIsShared() {
      if (this.selected) {
        const res = await dataListApi.shareSavedFilter(
          this.store,
          this.selected.id,
          this.isShared,
        );
        const message = this.isShared
          ? "Фильтр доступен всем пользователям"
          : "Фильтр не доступен всем пользователям";
        this.showInfo(message);
        this.$store.commit(`${this.store}/setFilters`, res);
        this.selected.isShared = this.isShared;
      }
    },
  },
};
</script>
